import axios from "axios";
import authHeader from "./auth-header";
import ICashBox from "../types/cash-box.type";
import ICashBoxChangeStatus from "../types/cash-box-change-status.type";
import ILiquidation from "../types/liquidation.type";
import ILiquidationChangeStatus from "../types/liquidation-change-status.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/liquidation`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (liquidation: ILiquidation) => {
  return axios.post(API_URL, liquidation, { headers: authHeader() });
};

export const update = (id: number, liquidation: ILiquidation) => {
  return axios.put(API_URL + "/" + id, liquidation, { headers: authHeader() });
};

export const changeStatus = (id: number, status: ILiquidationChangeStatus) => {
  return axios.put(API_URL + "/" + id + "/change-status", status, { headers: authHeader() });
};

export const getLiquidations = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getMyLiqiudations = (params: {}) => {
  return axios.get(API_URL + "/my-liquidations", { params: params, headers: authHeader() });
};

export const deleteById = (id: any) => {
  return axios.delete(API_URL + "/" + id, { headers: authHeader() });
};
